var React = require('react');

function AvatarBrand (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#0065ff","height":"24","rx":"3","width":"24","key":0}),React.createElement("path",{"d":"m12.608 12.532c.96 0 1.368.408 1.368 1.164 0 .72-.42 1.056-1.344 1.056h-2.16v-2.22zm-.288-3.204c.876 0 1.284.324 1.284 1.02s-.372 1.116-1.284 1.116h-1.848v-2.136zm-3.288 6.672h3.78c1.764 0 2.616-.864 2.616-2.124 0-1.116-.564-1.74-1.728-1.932.888-.216 1.332-.804 1.332-1.764 0-1.272-.78-2.064-2.388-2.064h-3.612z","fill":"#fff","key":1})]);
}

AvatarBrand.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = AvatarBrand;

AvatarBrand.default = AvatarBrand;
